import { Color } from "src/games/shared/ColorValue";

export class Character {
    public id: string;
    public assetNames: string[];
    public color: number;
    public backgroundAsset: string;
    public scale: number;

    public static EEBOT: Character = {
        id: "eebot",
        assetNames: ["robot1", "robot2", "robot3", "robot4"],
        color: Color.PLANET_COLORS.get("E"),
        backgroundAsset: "terrain",
        scale: 1.3
    };

    public static LIBRARIUS: Character = {
        id: "librarius",
        assetNames: ["librarius"],
        color: Color.PLANET_COLORS.get("C"),
        backgroundAsset: "terrain_c",
        scale: 0.9
    };

    public static MAJOR_SLJEM: Character = {
        id: "major-sljem",
        assetNames: ["mayor1", "mayor2"],
        color: Color.PLANET_COLORS.get("R"),
        backgroundAsset: "terrain_r",
        scale: 1.1
    };

    public static SQUEELO: Character = {
        id: "squeelo",
        assetNames: ["squeelo"],
        color: Color.PLANET_COLORS.get("R"),
        backgroundAsset: "terrain_r",
        scale: 0.8
    };

    public static PBJ17: Character = {
        id: "pbj-17",
        assetNames: ["pbj1"],
        color: Color.PLANET_COLORS.get("I"),
        backgroundAsset: "terrain_i",
        scale: 1.1
    };

    public static TUF: Character = {
        id: "2-tuf-2",
        assetNames: ["bandit1"],
        color: Color.PLANET_COLORS.get("S"),
        backgroundAsset: "terrain_s",
        scale: 1.1
    };

    public static CHARACTERS: Character[] = [
        Character.EEBOT,
        Character.LIBRARIUS,
        Character.MAJOR_SLJEM,
        Character.SQUEELO,
        Character.PBJ17,
        Character.TUF,
    ];

}



// WEBPACK FOOTER //
// ./src/games/ColonyGame/objects/Character.ts